"use client";
import { usePathname } from "next/navigation";
import { Header } from "./Header";
import { Footer } from "./Footer";
export function SiteChrome({ children }: { children: React.ReactNode }) {
  const path = usePathname();
  const admin = path === "/admin" || path.startsWith("/admin/");
  return (
    <>
      {!admin && <Header />}
      <main id="main-content">{children}</main>
      {!admin && <Footer />}
    </>
  );
}
